import { Link } from "react-router-dom";
import logoImage from "../../assest/images/logo-img.png";
import whiteLogoImage from "../../assest/images/whitelogo.png";
const Index = () => {
  return (
    <div className="loading-container">
      <div className="auth-card">
        <div className="logoSec mb-4">
          <Link to={"/"} className="comLogo logoimg">
            <img src={logoImage} alt="logo-img" width={200} />
          </Link>
          <Link to={"/"} className="whitelogo logoimg">
            <img src={whiteLogoImage} alt="logo-img" width={200} />
          </Link>
        </div>
        {/* The Branded Spinner */}
        <div className="spinner"></div>

        {/* The Title */}
        <h1>Session Secured</h1>
        <h1>Logging In as User...</h1>

        {/* The Detail Messages */}
        <p>Please wait while we establish a secure user session.</p>

        {/* The Subtle Hint */}
        <p className="small-text">
          Redirection will happen automatically once the token is validated.
        </p>
      </div>
    </div>
  );
};
export default Index;
